import React, { useState } from 'react';

function ToggleButtons({ setActiveButton, activeButton, label1 = "Enviar a usuario", label2 = "Enviar a Banco", button1 = "usuario", button2 = "banco" }) {
    // Estado para saber cuál botón está activo

    return (
        <div className="flex gap-4">
            {/* Botón: Enviar a usuario */}
            <button
                onClick={() => setActiveButton(button1)}
                className={`px-6 py-2 rounded-full font-medium transition-colors 
          ${activeButton === button1
                        ? 'bg-white text-black'
                        : 'bg-[#5E5E6329] text-white'
                    }
        `}
            >
                {label1}
            </button>

            {/* Botón: Enviar a Banco */}
            <button
                onClick={() => setActiveButton(button2)}
                className={`px-6 py-2 rounded-full font-medium transition-colors 
          ${activeButton === button2
                        ? 'bg-white text-black'
                        : 'bg-[#5E5E6329] text-white'
                    }
        `}
            >
                {label2}
            </button>
        </div>
    );
}

export default ToggleButtons;
